import React, { useEffect, useState } from 'react';
import '../Pages/css/TextAnimation.css'

const ScrollZoomText = () => {
    const [scrollPosition, setScrollPosition] = useState(0);

    useEffect(() => {
      const handleScroll = () => {
        // Get the current scroll position
        const currentPosition = window.scrollY;
  
        // Update the state with the current scroll position
        setScrollPosition(currentPosition);
      };
  
      // Attach the scroll event listener
      window.addEventListener('scroll', handleScroll);
  
      // Cleanup the event listener when the component unmounts
      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }, []); // Empty dependency array to run the effect only once on mount
  
    // Calculate the zoom factor based on the scroll position (adjust values as needed)
    const zoomFactor = 1 + scrollPosition / 500;
  
    return (
      <div className="text-container" style={{ transform: `scale(${zoomFactor})` }}>
        Your Text Content Here
      </div>
    );
  };
  


export default ScrollZoomText;
